import { useState } from 'react';

interface AvatarProps {
  email: string;
  className?: string;
}

export default function Avatar({ email, className = 'h-8 w-8' }: AvatarProps) {
  const username = email.split('@')[0];

  return (
    <div className={`rounded-full bg-primary-500 flex items-center justify-center text-white font-medium ${className}`}>
      {username.charAt(0).toUpperCase()}
    </div>
  );
} 